import { Badge, Card } from '../ui';
import type { Trainer } from '../../types';

interface TrainerCardProps {
  trainer: Trainer;
}

export function TrainerCard({ trainer }: TrainerCardProps) {
  return (
    <Card padding="lg" variant="elevated">
      <div className="flex flex-col gap-5 md:flex-row md:items-start">
        <div className="flex items-center gap-4 md:w-72">
          {trainer.photoURL ? (
            <img
              src={trainer.photoURL}
              alt={trainer.name}
              className="w-16 h-16 rounded-full object-cover"
            />
          ) : (
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-primary-500 to-accent-500 text-white flex items-center justify-center text-lg font-semibold">
              {trainer.name
                .split(' ')
                .map((part) => part[0])
                .join('')
                .toUpperCase()
                .slice(0, 2)}
            </div>
          )}
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-primary-600 dark:text-primary-400">
              Your Trainer
            </p>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              {trainer.name}
            </h2>
            <p className="text-sm text-gray-600 dark:text-slate-400">
              Personal Trainer
            </p>
          </div>
        </div>
        <div className="flex-1 space-y-4">
          {trainer.bio ? (
            <p className="text-sm text-gray-700 dark:text-slate-300 whitespace-pre-wrap">
              {trainer.bio}
            </p>
          ) : (
            <p className="text-sm text-gray-500 dark:text-slate-500">
              Your trainer has not added a bio yet.
            </p>
          )}
          {trainer.certifications && (
            <div className="flex flex-wrap gap-2">
              {trainer.certifications
                .split(',')
                .map((item) => item.trim())
                .filter(Boolean)
                .map((item) => (
                  <Badge key={item} variant="info">
                    {item}
                  </Badge>
                ))}
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}
